import React, {useState} from 'react';
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, CointainerFigureImage, ContainerChart } from '../../components/AppComponents';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { figure52 } from '../../graphs/ar/figure52';
import { figure53 } from '../../graphs/ar/figure53';

import Modal from "../../components/Modal";

const Sdg12 = () => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(false);

    const handleClickOpen = (value) => {
        setOpen(true);
        setText(value);
    };

    const handleClose = (value) => {
        setOpen(false);
        setText(value);
    };
    return (
      
        <React.Fragment>
            <Modal
                text={text}
                open={open}
                onClose={handleClose}
            />
            <ContainerCoverVideo 
                id="12" 
                poster={require('../../images/poster-sdg-12.png').default}
                video={require('../../images/video-sdg-12.mp4').default}
                sdgImage={require('../../images/EN_12.svg').default}
                sdg="الهدف 12 من أهداف التنمية المستدامة"
                title="الاستهلاك والإنتاج المسؤولان"
                subtitle="ضمان وجود أنماط استهلاك وإنتاج مستدامة"
                indicators={['12.3.1.a']}  
                indicatorsTitle="المؤشر"
                summaryTable={require('../../images/12.3.1a.pdf').default}
                summaryTableTitle= "(باللغة الإنجليزية) الخُمس الخامس"
            />

            <Container>
                <TitleSub title="نظرة عامة" />
<p>كان لوباء كوفيد-19 آثار كبيرة على أنماط الاستهلاك والإنتاج، مع اضطرابات في سلاسل التوريد العالمية وتغيرات في سلوك المستهلك. يجب أن يكون الاستهلاك والإنتاج المسؤولان جزءًا لا يتجزأ من التعافي من الوباء. يعد الحد من خسائر الأغذية وهدرها – التي لها آثار اجتماعية واقتصادية وبيئية سلبية – أمرًا بالغ الأهمية لتحقيق هذا الهدف. تسجل البلدان في جميع المناطق وفئات الدخل مستويات عالية من خسائر الأغذية وهدرها، مما يتطلب اتخاذ إجراءات عبر سلسلة القيمة، من الحصاد إلى الاستهلاك. لا تزال تقديرات الخسائر الغذائية العالمية ثابتة بين عامي 2016 و2021، مع وجود اختلافات كبيرة بين المناطق والمناطق دون الإقليمية. في عام 2019، فُقد 13.3 في المائة من جميع الأغذية المنتجة في مرحلتي الاستهلاك المسبق والتجزئة، وذهب 17 في المائة من الأغذية المتاحة للمستهلكين إلى صناديق النفايات الخاصة بالأسر وتجار التجزئة والمطاعم وغيرها من منافذ الخدمات الغذائية، وفقًا لبرنامج الأمم المتحدة للبيئة <span className="ref" onClick={() => handleClickOpen('<b>UNEP (United Nations Environment Programme).</b> 2021. <em>UNEP Food Waste Index report 2021.</em> Nairobi.')}>(UNEP، 2021).</span></p>
 <div id="section12.3.1.a">
                    <HeaderSdg 
                        title="مؤشر أهداف التنمية المستدامة 12.3.1.a"
                        subtitle="مؤشر الفاقد الغذائي"
                        badges={[
                            {color: '#cecece', text: 'تقييم الحالة العالمية: بعيد جدًا عن الهدف'},
                            { color: '#FFFF00', text: 'تقييم الاتجاهالعالمي: لا يوجد تحسّن'},
                        ]}
                        target={{
                            sdg: "12",
                            title: 'الهدف 12.3',
                            text: '12-3 تخفيض نصيب الفرد من النفايات الغذائية العالمية على صعيد أماكن البيع بالتجزئة والمستهلكين بمقدار النصف، والحد من خسائر الأغذية في مراحل الإنتاج وسلاسل الإمداد، بما في ذلك خسائر ما بعد الحصاد، بحلول عام 2030'
                        }}
                    />
                </div>

<p><i>تشير التقديرات إلى أن خسارة الغذاء العالمية في عام 2021 بلغت 13.2 في المائة، على غرار السنوات السابقة</i></p>
<p>تقدر النسبة المئوية للأغذية المفقودة على مستوى العالم بعد الحصاد على مستويات المزرعة والنقل والتخزين والبيع بالجملة والتجهيز بنسبة 13.2 في المائة في عام 2021. وهذا مشابه للتقديرات السابقة البالغة 13.3 في المائة و13 في المائة في عامي 2020 و2016 على التوالي، عندما بدأ الإبلاغ لأول مرة. تتوافق هذه النسب المئوية، من حيث مؤشر فقد الأغذية (FLI)، مع 98.7 في عام 2016، و101.2 في عام 2020 و98.27 في عام 2021. يجب تفسير هذه التغييرات على أنها تذبذبات لأن المناطق لم تشهد سوى اختلافات طفيفة منذ عام 2020، مع عدم ظهور اتجاهات واضحة أو مهمة.</p>
<p>وعلى المستوى الإقليمي، تسجل أفريقيا جنوب الصحراء الكبرى أعلى الخسائر بنسبة 19.95 في المائة، تليها الدول الجزرية الصغيرة النامية وأقل البلدان نمواً بنسبة 18.99 في المائة و16.1 في المائة على التوالي، ويعزى ذلك إلى أوجه القصور الهيكلية في البلدان. سجلت أمريكا اللاتينية ومنطقة البحر الكاريبي أيضًا أرقامًا عالية لفقدان الغذاء، بنسبة 14.52 في المائة، بزيادة 2.3 في المائة منذ عام 2020. ويعزى ذلك إلى زيادة مستويات الخسارة في منطقة البحر الكاريبي دون الإقليمية نتيجة لزيادة توافر البيانات، وليس بالضرورة تغييراً في الخسائر المتكبدة.</p>
<p>وحدثت أقل الخسائر في أوقيانوسيا (باستثناء أستراليا ونيوزيلندا) وأمريكا الشمالية وأوروبا، بنسبة 12.43 في المائة و9.19 في المائة على التوالي.</p>
<p>شهدت جميع المناطق اختلافات طفيفة (زيادة ونقصان) عن التقديرات المبلغ عنها في عام 2020. ومع ذلك، لم تكن هذه مهمة بما يكفي لاستخدامها للإبلاغ عن الاتجاهات. وكانت أعلى الاختلافات هي انخفاض بنسبة 2.5 في المائة بالنسبة لأقل البلدان نمواً، وانخفاض بنسبة 2.4 في المائة في أوقيانوسيا (باستثناء أستراليا ونيوزيلندا) وزيادة بنسبة 2.3 في المائة في أمريكا اللاتينية ومنطقة البحر الكاريبي.</p>
</Container>
<ContainerChart
                title="الشكل 52. النسب المئوية لفقدان الأغذية حسب المنطقة (2016 و2021) "
                legend={[
                    {title: '2016', color: '#bf9000'},
                    {title: '2021', color: '#ffd966'},
                ]}
                note={<span>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals-data-portal/data/ar">www.fao.org/sustainable-development-goals-data-portal/data/ar</a><br/><a href="https://doi.org/10.4060/CC7088EN-fig52" download>https://doi.org/10.4060/CC7088EN-fig52</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure52}
                />
</ContainerChart>
<Container>
<p>وعلى المستوى دون الإقليمي، تسجل منطقة غرب أفريقيا أعلى نسبة خسارة تبلغ 23.57 في المائة. ويتسق هذا مع تقديرات عام 2020 البالغة 24.8 في المائة، بالنظر إلى أن أفريقيا جنوب الصحراء الكبرى تعاني من أحد أعلى أوجه القصور الهيكلية. المنطقة دون الإقليمية التي سجلت ثاني أعلى الخسائر هي منطقة البحر الكاريبي، بنسبة 22.55 في المائة، وهي زيادة بنسبة 4 في المائة عن تقديرات عام 2020 التي قدرت الخسائر بنسبة 18.9 في المائة. ومع ذلك، فإن هذه التغييرات لا تعكس بالضرورة حالة متدهورة، بل زيادة في البيانات المتاحة للمنطقة.</p>
<p>وعادة ما تعاني البلدان ذات الدخل المرتفع من خسائر غذائية أقل، حيث سجلت أقل الخسائر في أوروبا: 7.25 في المائة، وهي زيادة طفيفة بالنسبة للمنطقة عن تقديرات عام 2020 البالغة 6.01 في المائة. وباتخاذ وجهة نظر أكثر تفصيلاً، فإن أوروبا الشرقية لديها أقل خسائر في الغذاء بنسبة 5.01 في المائة، تليها أوروبا الغربية والجنوبية بنسبة 7.84 في المائة و8.08 في المائة على التوالي. تبرز أوروبا الشمالية بمعدل خسارة مسجل أعلى عند 11.7 في المائة. يمكن أن تعزى التغيرات في تقديرات خسائر الغذاء على المستوى الإقليمي ودون الإقليمي بين عامي 2020 و2021 إلى اتجاهات وتذبذبات نموذجية ليست بالضرورة مؤشراً على التغيرات الهيكلية في المناطق، مما يجعل من المستحيل الإبلاغ عن هذا الاتجاه.</p>
<p>في حين أن البيانات على المستوى القطري لا تزال شحيحة، فإن التقديرات العالية للخسائر على المستوى العالمي والإقليمي ودون الإقليمي تشير إلى حجم المشكلة، وبالتالي، الحاجة إلى أن تبدأ البلدان في صياغة سياسات موجهة خصيصًا نحو الحد من خسائر الغذاء.</p>
</Container>
<ContainerChart
                title="الشكل 53. مؤشر فقدان الغذاء، النسب المئوية حسب المنطقة دون الإقليمية (2021)"
                legend={[
                    
                ]}
                note={<span>ملاحظة: يشير مؤشر فقدان الغذاء إلى النسبة المئوية لفقدان الغذاء مقارنة بسنة الأساس 2015.<br/>المصدر: منظمة الأغذية والزراعة. 2023. المؤشرات. في: <i>أهداف التنمية المستدامة</i>. روما. مقتبس في 8 يونيو 2023. <a href="http://www.fao.org/sustainable-development-goals/indicators/en">www.fao.org/sustainable-development-goals-data-portal/data/ar</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure53}
                />
</ContainerChart>
<Container>
<p className="font-weight-bold" dir="auto">المرجع:</p>
<p>برنامج الأمم المتحدة للبيئة 2021. <i>تقرير مؤشر النفايات الغذائية لبرنامج الأمم المتحدة للبيئة لعام 2021</i>. نيروبي</p>
<br/><br/>
</Container>

            
        </React.Fragment>
    ) 
}


export default Sdg12;
